import { useState } from "react";
import axios from "axios";
import { Check, Loader2 } from "lucide-react";
import { formatCHF } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PromoCodeField = ({ email, promo, onChange }) => {
  const [code, setCode] = useState(promo?.code || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const apply = async () => {
    if (!email) { setError("Saisissez d'abord votre e-mail ci-dessus."); return; }
    setBusy(true); setError(null);
    try { const { data } = await axios.post(`${API}/promo-location/verifier`, { code, email }); onChange(data); }
    catch (e) { onChange(null); setError(e.response?.data?.detail || "Code promo invalide"); }
    finally { setBusy(false); }
  };
  if (promo) return (
    <div className="flex items-center justify-between gap-3 border border-sage/40 bg-sage/10 px-4 py-3 text-sm" data-testid="stage-promo-applied">
      <span className="flex items-center gap-2 text-bark"><Check className="w-4 h-4 text-sage" />{promo.libelle} : − {formatCHF(promo.montant)} <span className="font-mono text-xs text-fumee">{promo.code}</span></span>
      <button type="button" onClick={() => { onChange(null); setCode(""); }} className="text-xs text-terra" data-testid="stage-promo-remove">Retirer</button>
    </div>
  );
  return (
    <div>
      <span className="eyebrow block mb-2">Code promo (facultatif)</span>
      <div className="flex gap-2">
        <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="ELM-TAM-XXXXXX" data-testid="stage-promo-input" className="flex-1 min-w-0 bg-white/60 border border-wood/25 rounded-xl px-4 py-3 text-base sm:text-sm font-mono focus:outline-none focus:border-terra" />
        <button type="button" onClick={apply} disabled={busy || code.trim().length < 6} data-testid="stage-promo-apply" className="px-5 rounded-full border border-earth text-earth text-sm disabled:opacity-40 inline-flex items-center gap-2">{busy && <Loader2 className="w-4 h-4 animate-spin" />}Appliquer</button>
      </div>
      {error && <p className="text-xs text-destructive mt-2" data-testid="stage-promo-error">{error}</p>}
    </div>
  );
};
